import { render, staticRenderFns } from "./ReportPieChart.vue?vue&type=template&id=1c6ee977&"
import script from "./ReportPieChart.vue?vue&type=script&lang=js&"
export * from "./ReportPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports